export default "__VITE_ASSET__Cv1P9Ney__"